// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "teseo-3b516.firebaseapp.com",
  projectId: "teseo-3b516",
  storageBucket: "teseo-3b516.appspot.com",
  messagingSenderId: "386035324434",
  appId: "1:386035324434:web:12f25b99adbacc2275eacb",
  measurementId: "G-4Q65CR2GLF"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
auth.languageCode = 'it';
export const db = getFirestore(app);
export const usersCollection = collection(db, "users_data_v2");